import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { SendPushNotificationRequest } from '../client-sdk/api';

export const usePushNotificationApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createPushNotification = useCallback(
    async (choiceData: SendPushNotificationRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.sendPushNotification(choiceData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );


  return {
    createPushNotification,  
    loading,
    error,
  };
};
